var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: {
            width: 1300,
            "footer-hide": true,
            title: "意向单明细",
            scrollable: true,
          },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _vm.innerSpin
            ? _c("Spin", { attrs: { size: "large", fix: "" } })
            : _vm._e(),
          _c(
            "Card",
            { attrs: { padding: 0, bordered: false, "dis-hover": true } },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "Form",
                        {
                          staticClass: "form-input-no-outline",
                          attrs: { "label-position": "top" },
                        },
                        [
                          _c(
                            "Row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "订单号" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord
                                              .intentionBillRecordCode,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "苗场" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.orderRecord.seedFarmName,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "定单时间" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.formatDateTimeString(
                                            _vm.orderRecord
                                              .intentionBillRecordCreateAt
                                          ),
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "2" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "周期" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.orderRecord.weekSeq,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "发货时间" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.formatDateString(
                                            _vm.orderRecord
                                              .intentionBillRecordSendProductDate
                                          ),
                                        },
                                        model: {
                                          value: _vm.sendDeliveryDate,
                                          callback: function ($$v) {
                                            _vm.sendDeliveryDate = $$v
                                          },
                                          expression: "sendDeliveryDate",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "2" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "定单总额(元)" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.orderRecord.totalMoney,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Row",
                            { attrs: { gutter: 24 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "关联销售单号" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord
                                              .intentionBillRecordRelatepreSaleOrderRecordCode,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "10" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "客户地址" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord.receiptFullAddress,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "6" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "客户经理" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.orderRecord.customerName,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Row",
                            { attrs: { gutter: 24 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "8" } },
                                [
                                  _vm.$checkAccessArray(["S", "B"])
                                    ? _c(
                                        "FormItem",
                                        { attrs: { label: "客户备注" } },
                                        [
                                          _c("Input", {
                                            attrs: {
                                              value:
                                                _vm.orderRecord.customerMsg,
                                              readonly: "",
                                              type: "textarea",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "6" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "佣金比例" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord
                                              .intentionBillDetailsalesAssociateCommissionPercent,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Row",
                            { attrs: { gutter: 24 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "24" } },
                                [
                                  _c(
                                    "Row",
                                    {
                                      staticStyle: { "margin-bottom": "5px" },
                                      attrs: { gutter: 30 },
                                    },
                                    [
                                      _c("Col", { attrs: { span: "12" } }, [
                                        _vm._v("意向单明细"),
                                      ]),
                                      _c(
                                        "Col",
                                        {
                                          staticStyle: {
                                            "text-align": "right",
                                          },
                                          attrs: { span: "12" },
                                        },
                                        [
                                          _vm.$checkAccessArray(["B", "C"])
                                            ? _c(
                                                "Button",
                                                {
                                                  staticStyle: {
                                                    "margin-right": "10px",
                                                  },
                                                  attrs: { type: "success" },
                                                  on: {
                                                    click: _vm.updateCustomer,
                                                  },
                                                },
                                                [_vm._v("修改客户经理")]
                                              )
                                            : _vm._e(),
                                          _vm.$checkAccessArray(["B", "C", "G"])
                                            ? _c(
                                                "Button",
                                                {
                                                  staticStyle: {
                                                    "margin-right": "10px",
                                                  },
                                                  attrs: {
                                                    disabled:
                                                      _vm.planProductsNoInDetail
                                                        .length < 1,
                                                    type: "primary",
                                                  },
                                                  on: {
                                                    click: _vm.InserDetailInfo,
                                                  },
                                                },
                                                [_vm._v("新增产品")]
                                              )
                                            : _vm._e(),
                                          _vm.$checkAccessArray(["B", "C", "G"])
                                            ? _c(
                                                "Poptip",
                                                {
                                                  staticStyle: {
                                                    "margin-right": "10px",
                                                  },
                                                  attrs: {
                                                    confirm: "",
                                                    placement: "left",
                                                    title:
                                                      "请确认信息是否无误？",
                                                  },
                                                  on: {
                                                    "on-ok": _vm.saveDetailInfo,
                                                    "on-cancel": _vm.cancel,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "Button",
                                                    { attrs: { type: "info" } },
                                                    [_vm._v("批量保存")]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "FormItem",
                                    [
                                      _c("Table", {
                                        ref: "mainTable",
                                        attrs: {
                                          size: "small",
                                          columns: _vm.orderDetail.columns,
                                          data: _vm.orderDetail.rows,
                                          stripe: "",
                                          border: "",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "intentionBillDetailProductName",
                                            fn: function ({ row, index }) {
                                              return [
                                                row.intentionBillDetailUuid ==
                                                  "insert" &&
                                                !row.intentionBillDetailProductCode
                                                  ? _c(
                                                      "Select",
                                                      {
                                                        staticStyle: {
                                                          "text-align": "left",
                                                        },
                                                        attrs: {
                                                          placeholder:
                                                            "选择品名",
                                                          filterable: "",
                                                        },
                                                        on: {
                                                          "on-change":
                                                            function ($event) {
                                                              return _vm.onProductSelectChange(
                                                                $event,
                                                                row
                                                              )
                                                            },
                                                        },
                                                        model: {
                                                          value:
                                                            row.productUuid,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              row,
                                                              "productUuid",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "row.productUuid",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.planProductsNoInDetail,
                                                        function (item) {
                                                          return _c(
                                                            "Option",
                                                            {
                                                              key: item.productName,
                                                              attrs: {
                                                                value:
                                                                  item.productName,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.productName
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  : row.intentionBillDetailProductPrice ==
                                                    "定金"
                                                  ? _c("div", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getDepositRate
                                                        )
                                                      ),
                                                    ])
                                                  : _c("div", [
                                                      _vm._v(
                                                        _vm._s(
                                                          row.intentionBillDetailProductName
                                                        )
                                                      ),
                                                    ]),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "text-align": "right" } },
                [
                  _c(
                    "Button",
                    {
                      staticStyle: { "margin-right": "20px" },
                      attrs: { type: "info" },
                      on: { click: _vm.sumbitIntentionGetOrder },
                    },
                    [_vm._v("审核")]
                  ),
                  _c(
                    "Button",
                    {
                      attrs: { type: "error" },
                      on: {
                        click: function ($event) {
                          _vm.show = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
              _c(
                "Modal",
                {
                  attrs: {
                    title: "审核意向单",
                    "class-name": "vertical-center-modal",
                    width: "800",
                  },
                  model: {
                    value: _vm.approveModel.show,
                    callback: function ($$v) {
                      _vm.$set(_vm.approveModel, "show", $$v)
                    },
                    expression: "approveModel.show",
                  },
                },
                [
                  _vm.innerSpin
                    ? _c("Spin", { attrs: { size: "large", fix: "" } })
                    : _vm._e(),
                  _c(
                    "Form",
                    { attrs: { "label-position": "top" } },
                    [
                      _c(
                        "Row",
                        { attrs: { gutter: 16 } },
                        [
                          _c(
                            "Col",
                            { attrs: { span: "6" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "审核状态:",
                                    prop: "approveStatus",
                                  },
                                },
                                [
                                  _c(
                                    "RadioGroup",
                                    {
                                      attrs: { type: "button" },
                                      model: {
                                        value: _vm.approveModel.approveStatus,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.approveModel,
                                            "approveStatus",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "approveModel.approveStatus",
                                      },
                                    },
                                    [
                                      _c(
                                        "Radio",
                                        { key: 1, attrs: { label: 1 } },
                                        [_vm._v("审核通过")]
                                      ),
                                      _c(
                                        "Radio",
                                        { key: 2, attrs: { label: 2 } },
                                        [_vm._v("审核不通过")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c("div", [
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*"),
                                ]),
                                _vm._v("审核备注:"),
                              ]),
                              _c(
                                "FormItem",
                                { attrs: { label: "", prop: "approveRemark" } },
                                [
                                  _c("Input", {
                                    attrs: { type: "textarea", row: 5 },
                                    model: {
                                      value: _vm.approveModel.approveRemark,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.approveModel,
                                          "approveRemark",
                                          $$v
                                        )
                                      },
                                      expression: "approveModel.approveRemark",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c(
                        "Button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSaveApprove },
                        },
                        [_vm._v("确认")]
                      ),
                      _c(
                        "Button",
                        {
                          attrs: { type: "error" },
                          on: {
                            click: function ($event) {
                              _vm.approveModel.show = false
                            },
                          },
                        },
                        [_vm._v("取消")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Modal",
                {
                  attrs: {
                    title: "修改客户经理",
                    "class-name": "vertical-center-modal",
                    width: "800",
                  },
                  model: {
                    value: _vm.customerModel.show,
                    callback: function ($$v) {
                      _vm.$set(_vm.customerModel, "show", $$v)
                    },
                    expression: "customerModel.show",
                  },
                },
                [
                  _vm.innerSpin
                    ? _c("Spin", { attrs: { size: "large", fix: "" } })
                    : _vm._e(),
                  _c(
                    "Form",
                    { attrs: { "label-position": "top" } },
                    [
                      _c(
                        "Row",
                        { attrs: { gutter: 16 } },
                        [
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "选择客户经理:" } },
                                [
                                  _c(
                                    "Select",
                                    {
                                      staticStyle: { width: "200px" },
                                      attrs: { filterable: "", clearable: "" },
                                      on: {
                                        "on-change": _vm.updateSelectCustomer,
                                      },
                                      model: {
                                        value: _vm.customerModel.customerId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.customerModel,
                                            "customerId",
                                            $$v
                                          )
                                        },
                                        expression: "customerModel.customerId",
                                      },
                                    },
                                    _vm._l(_vm.customerList, function (item) {
                                      return _c(
                                        "Option",
                                        {
                                          key: item.userCustomerManagerLoginUuid,
                                          attrs: {
                                            value:
                                              item.userCustomerManagerLoginUuid,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(item.userCustomerManagerName)
                                          ),
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c(
                        "Button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSaveCustomer },
                        },
                        [_vm._v("确认")]
                      ),
                      _c(
                        "Button",
                        {
                          attrs: { type: "error" },
                          on: {
                            click: function ($event) {
                              _vm.customerModel.show = false
                            },
                          },
                        },
                        [_vm._v("取消")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }